import {} from '@sentry/core';
import {} from '@sentry/react';
import { useEffect } from 'react';
import useShallowMemo from 'use-shallow-memo';
import useSentrySdk from '../../hooks/use-sentry-sdk.js';
export default function useSentry({ user, ...browserOptions }) {
    const { init, setUser } = useSentrySdk();
    const memoizedBrowserOptions = useShallowMemo(browserOptions);
    useEffect(() => {
        init(memoizedBrowserOptions);
    }, [init, memoizedBrowserOptions]);
    useEffect(() => {
        setUser({
            ip_address: '{{auto}}',
            ...user,
        });
    }, [setUser, user]);
}
//# sourceMappingURL=sentry.hook.js.map